import React from 'react';
import ReactEcharts from 'echarts-for-react';
import {
    Table,
    Row,
    Spin,
    Tooltip,
    Button,
    Popconfirm,
    Tabs,
    Card,
    Icon,
    Popover,
    Form,
    DatePicker,
    Col,
    Input,
} from 'antd';
const FormItem = Form.Item;
import { Link } from 'react-router-dom';
import { asyncGet,getTestA,getErrorRate,getErrorRateChart,delProxyKey, getAllDataSize, getDataSize, getDeviceInfo,actions,getTaskDeviceInfo,getCheckPvGap,getBlockingTaskMonitorUrl} from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
// import Edit from './edit.js';
import { delect, delectAll } from './reducers';

import {formatFormData} from "../../sign/signList/utils";
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const TabPane = Tabs.TabPane;

class AgencyAnalysis extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();//
        //this.props.getErrorRate();
        //this.props.getErrorRateChart();
        this.props.getAllDataSize();//
        this.props.getDataSize();//
        // this.props.getDeviceInfo();
        // this.props.getBlockingTaskMonitorUrl();
        // this.props.getCheckPvGap();
        // this.props.getTaskDeviceInfo();
        // this.props.getCheckPvGap();
    }
    handleReset= () => {
        this.props.form.resetFields();
    }
    removeProxyItem(keyName) {
        try {
            this.props.delProxyKey(keyName).then(() => {
                this.props.asyncGet();
            });
        } catch (err) {
            alert(err);
        }
    }
    // 查询
    handleSearch = (dates, dateStrings) =>{
        let values={"date":dates};
        console.log('=====searchValue', values);
        this.props.changeTaskDeviceSearchValues(formatFormData(values));
        this.props.getTaskDeviceInfo();
    }

    // changeHandle = (pagination, filters, sorter) => {
    //     this.props.changePagination(pagination);
    //     this.props.asyncGet();
    //     this.props.getErrorRate();
    // };

    edit = record => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record.scriptId);
    }

    // handleDelete = async record => {
    //     record.deleteFlag = '1';
    //     this.props.delect(record);
    //     this.props.asyncGet();
    //     this.props.getErrorRate();
    // }

    // renderAction = (text, record) => {
    //     return (
    //         <div>
    //             <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => { this.edit(record); }} >
    //                 编辑
    //             </Button>
    //
    //             <Popconfirm title="是否删除?" onConfirm={() => { this.handleDelete(record); }} >
    //                 <Button type="primary" style={{ marginRight: '5px' }} size="small">
    //                     < a href="#">删除</a>
    //                 </Button>
    //             </Popconfirm>
    //         </div>
    //     );
    // };

    // onSelectChange = (selectedRowKeys, selectedRows) => {
    //     this.props.getTransferData({ selectedRowKeys });
    // };
    getOptionForDevice(data) {

        let dataList = [];
        let seriesList = [];
        if(data.length){
            dataList =  data.map(item=>{
                return item.name
            })
            seriesList = data.map(item=>{
                return {
                    value: item.value,
                    name: item.name
                }
            })
        }
        // console.log('options=======', legendData, seriesData)
        const option = {
            title : {
                text: '设备号占比',
                //subtext: '纯属虚构',
                x:'center'
            },
            tooltip : {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
                orient : 'vertical',
                x : 'left',
                data:dataList
            },
            toolbox: {
                show : true,
                feature : {
                    mark : {show: true},
                    dataView : {show: true, readOnly: false},
                    magicType : {
                        show: true,
                        type: ['pie', 'funnel'],
                        option: {
                            funnel: {
                                x: '25%',
                                width: '50%',
                                funnelAlign: 'left',
                                max: 1548
                            }
                        }
                    },
                    restore : {show: true},
                    saveAsImage : {show: true}
                }
            },
            calculable : true,
            series : [
                {
                    name:'',
                    type:'pie',
                    radius : '55%',
                    center: ['50%', '60%'],
                    data:seriesList
                }
            ]
        };

        return option;
    }

    getOption1(data) {

        let dataList = [];
        let seriesList = [];
        if(data.length){
           dataList =  data.map(item=>{
                return item.name
            })
            seriesList = data.map(item=>{
                return {
                    value: item.value,
                    name: item.name
                }
            })
        }
        // console.log('options=======', legendData, seriesData)
        const option = {
            title : {
                text: '错误占比',
                //subtext: '纯属虚构',
                x:'center'
            },
            tooltip : {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
                orient : 'vertical',
                x : 'left',
                data:dataList
            },
            toolbox: {
                show : true,
                feature : {
                    mark : {show: true},
                    dataView : {show: true, readOnly: false},
                    magicType : {
                        show: true,
                        type: ['pie', 'funnel'],
                        option: {
                            funnel: {
                                x: '25%',
                                width: '50%',
                                funnelAlign: 'left',
                                max: 1548
                            }
                        }
                    },
                    restore : {show: true},
                    saveAsImage : {show: true}
                }
            },
            calculable : true,
            series : [
                {
                    name:'',
                    type:'pie',
                    radius : '55%',
                    center: ['50%', '60%'],
                    data:seriesList
                }
            ]
        };

        return option;
    }

    getOption2(data) {
        let dateList = [];
        let legendData = [];
        let seriesData = [];
        if (data.length) {
            dateList = data[0].detail.map(item => {
                return item.time;
            });
            legendData = data.map(item => item.time);
            seriesData = data.map(item => {
                let {detail} = item;
                let ip = detail.map(d => d.ipDistinctCount);
                return {
                    name: item.time,
                    type: 'line',
                    smooth: false,
                    symbol: 'none',
                    sampling: 'average',
                    markLine: {},
                    data: ip,
                };
            });
        }
        // console.log('options=======', legendData, seriesData)
        const option = {
            title : {
                text: '某地区蒸发量和降水量',
                subtext: '纯属虚构'
            },
            tooltip : {
                trigger: 'axis'
            },
            legend: {
                data:['蒸发量','降水量']
            },
            toolbox: {
                show : true,
                feature : {
                    mark : {show: true},
                    dataView : {show: true, readOnly: false},
                    magicType : {show: true, type: ['line', 'bar']},
                    restore : {show: true},
                    saveAsImage : {show: true}
                }
            },
            calculable : true,
            xAxis : [
                {
                    type : 'category',
                    data : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
                }
            ],
            yAxis : [
                {
                    type : 'value'
                }
            ],
            series : [
                {
                    name:'蒸发量',
                    type:'bar',
                    data:[2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],

                },
                {
                    name:'降水量',
                    type:'bar',
                    data:[2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],


                }
            ]
        };

        return option;
    }
    renderTaskInfo = (text, record) => {
        let content = (
            <div>
                <p>订单名称：{record.taskDesc}</p>
                <p>任务类型：{record.taskType}</p>
            </div>
        );

        return (
            <Popover content={content} title="任务详情"  placement="top">
                <Link
                    to={`/statistics/task/${record.taskId}`}
                    style={{ color: record.taskAssignNum !== 0 && record.successCount === 0 ? 'red' : '#108ee9' }}>
                    {record.taskId}
                </Link>
            </Popover>
        );
    };
    render() {
        let { searchValues,list, uiStatus, threadList,charts,getTest,errorRate,errorRateChart, allDataSize, dataSize,deviceInfo,taskDeviceInfo,checkPvGap,blockingTaskMonitorQuery} = this.props;
        let {  isLoading, isUpdateShow, isSendCommend, isLoadingAllProxyPoolLength,
            isLoadingDeviceInfo, isLoadingErrorRate,isLoadingAllDataSize, isLoadingDataSize,isLoadingTaskDeviceInfo,
            isLoadingErrorRateChart,isLoadingBlockingTaskMonitorQuery } = uiStatus;

      /*  console.log('list',list);*/
        const columns = [
            {
                title: '任务ID',
                dataIndex: 'adId',
                key: 'adId',
            },
            {
                title: '广告位ID',
                dataIndex: 'ps',
                key: 'ps',
            },
            {
                title: '任务名',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '成功数量',
                dataIndex: 'successNum',
                key: 'successNum',
                sorter: (a, b) => a.successNum - b.successNum,
            },
            {
                title: '失败数量',
                dataIndex: 'errorNum',
                key: 'errorNum',
                sorter: (a, b) => a.errorNum - b.errorNum,
            },
            {
                title: '总量',
                dataIndex: 'sum',
                key: 'sum',
                sorter: (a, b) => a.sum - b.sum,
            },
            {
                title: '任务错误率',
                dataIndex: 'errorRate',
                key: 'errorRate',
                sorter: (a, b) => a.errorRate - b.errorRate,
                render: num => <h4>{Math.round(num*100)/100}</h4>
            },

        ];
        const clolumnsForDevices = [
            {
                title: '地区',
                dataIndex: 'provinceName',
                key: 'provinceName',
            },
            {
                title: 'key',
                dataIndex: 'key',
                key: 'key',
            },
            {
                title: '宽度',
                dataIndex: 'length',
                key: 'length',
                sorter: (a, b) => a.length - b.length,
            },
        ];
        const clolumnsTaskForDevices = [
            {
                title: 'taskId',
                dataIndex: 'taskId',
                key: 'taskId',
                render: (text, record) => {return this.renderTaskInfo(text, record)},
            },
            {
                title: 'provinceName',
                dataIndex: 'provinceName',
                key: 'provinceName',
            },
            {
                title: '目标量',
                dataIndex: 'targetPv',
                key: 'targetPv',
            },
            {
                title: '设备号数量',
                dataIndex: 'length',
                key: 'length',
                sorter: (a, b) => a.length - b.length,
            },
            {
                title: 'ip数',
                dataIndex: 'ipCount',
                key: 'ipCount',
                sorter: (a, b) => a.ipCount - b.ipCount,
            },
            {
                title: '设备号key',
                dataIndex: 'key1',
                key: 'key1',
            },
        ];
        const columns0 = [
            {
                title: '任务ID',
                dataIndex: 'adId',
                key: 'adId',
            },
            {
                title: '广告位ID',
                dataIndex: 'ps',
                key: 'ps',
            },
            {
                title: '任务名',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '到达监测数量',
                dataIndex: 'irCount1',
                key: 'irCount1',
                sorter: (a, b) => a.irCount1 - b.irCount1,
            },
            {
                title: '互动监测数量',
                dataIndex: 'irCount2',
                key: 'irCount2',
                sorter: (a, b) => a.irCount2 - b.irCount2,
            },

        ];

        const  columns1 = [
            {
                title:'描述',
                dataIndex: 'descripton',
                key: 'descripton'
            },
            {
                title: 'keyName',
                dataIndex: 'keyName',
                key: 'keyName',
                // render: (text, record) => {
                //     return (
                //         <Tooltip placement="right" title={record.descripton}>
                //             <Button>{text}</Button>
                //         </Tooltip>
                //     );
                // },
            },
            {
                title: '宽度',
                dataIndex: 'length',
                key: 'length',
                render: (text, record) => <p style={{ color: record.limit < record.length?'red':'' }} >{text}</p>,
            },
            {
                title:'限制',
                dataIndex:'limit',
                key:'limit'
            },
            {
                title: '操作',
                render: (text, record) => {
                    return (
                        <Popconfirm
                            title="确定删除？"
                            onConfirm={() => {this.removeProxyItem(record.keyName)}}
                            okText="确定"
                            cancelText="取消">
                            <a href="javascript:;">删除</a>
                        </Popconfirm>
                    );
                },
            }

        ];
        const  columns2 = [

            {
                title:'广告ID',
                dataIndex: 'adId',
                key: 'adId'
            },
            {
                title: '任务名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '消耗带宽(M)',
                dataIndex: 'allDataSize',
                key: 'allDataSize',
                sorter: (a, b) => a.allDataSize - b.allDataSize,
                render: (text, record) => <p style={{ color: record.limit < record.length?'red':'' }} >{text}</p>,
            },

        ];
        const  columns3 = [

            {
                title:'广告ID',
                dataIndex: 'adId',
                key: 'adId'
            },
            {
                title:'ps',
                dataIndex: 'ps',
                key: 'ps'
            },
            {
                title: '任务名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '任务页面大小(kb)',
                dataIndex: 'dataSize',
                key: 'dataSize',
                sorter: (a, b) => a.dataSize - b.dataSize,
                render: (text, record) => <p style={{ color: record.limit < record.length?'red':'' }} >{text}</p>,
            },

        ];
        const dateFormat = 'YYYY-MM-DD';
        const expandedRowRender = (dataJson) => {
            const columns = [
                {
                    title:'任务 ID',
                    dataIndex: 'taskId',
                    key: 'taskId'
                },
                {
                    title:'阻塞数量',
                    dataIndex: 'blockingNum',
                    key: 'blockingNum'
                },

            ];

            if(dataJson){
                const data = [];
                for (let i = 0; i < dataJson.taskBlockingInfos.length; ++i) {
                    data.push({
                        taskId: dataJson.taskBlockingInfos[i].taskId,
                        blockingNum: dataJson.taskBlockingInfos[i].blockingNum,
                    });
                }
                return (
                    <Table
                        bordered={true}
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                    />
                );
            }else{
                return (<span>没有更多信息</span>)
            }

        };

        const columnsBlockingTaskMonitorQuery = [
            {
                title:'机器 IP',
                dataIndex: 'workerIp',
                key: 'workerIp'
            },
            {
                title:'阻塞数量',
                dataIndex: 'totalBlockingNum',
                key: 'totalBlockingNum'
            },
        ];

        const dataBlockingTaskMonitorQuery = [];
        for (let i = 0; i < blockingTaskMonitorQuery.length; ++i) {
            dataBlockingTaskMonitorQuery.push({
                key: i,
                workerIp: blockingTaskMonitorQuery[i].workerIp,
                totalBlockingNum: blockingTaskMonitorQuery[i].totalBlockingNum,
                taskBlockingInfos: blockingTaskMonitorQuery[i].taskBlockingInfos
            });
        }

        const  columns4 = [

            {
                title:'广告ID',
                dataIndex: 'adId',
                key: 'adId'
            },
            {
                title:'ps',
                dataIndex: 'ps',
                key: 'ps'
            },
            {
                title: '任务名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '任务ID',
                dataIndex: 'taskId',
                key: 'taskId',
            },
            {
                title: '探针到达时间',
                dataIndex: 'arriveTime',
                key: 'arriveTime',
                sorter: (a, b) => a.arriveTime - b.arriveTime,
                render: (text, record) => <p style={{ color: record.limit < record.length?'red':'' }} >{text}</p>,
            },

        ];
        const  columns5 = [

            {
                title:'广告ID',
                dataIndex: 'eId',
                key: 'eId'
            },
            {
                title:'ps',
                dataIndex: 'ps',
                key: 'ps'
            },
            {
                title: '任务名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '任务ID',
                dataIndex: 'taskId',
                key: 'taskId',
            },
            {
                title: '恒紫量',
                dataIndex: 'hzCount',
                key: 'hzCount',
            },

            {
                title: '广告量',
                dataIndex: 'pv',
                key: 'pv',
            },
        ];


        return (
            <div style={{ marginBottom: '20px'}}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>
                    {/* <div className="tabTop" style={{ marginRight: '30px'}}>
                            <h1>错误率
                                <Icon
                                    className='reload'
                                    type="reload"
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        float: 'right',
                                        marginTop: '5px',
                                        marginRight: '5px',
                                    }}
                                    onClick={()=>{this.props.getErrorRate()}}
                                />
                            </h1>
                            <div className="tabCon" style = {{marginRight: '30px'}}>

                                    <Tabs defaultActiveKey="1" tabBarStyle={{background:'#f7f7f7'}}>
                                        <TabPane tab="图" key="1">
                                            <Spin spinning={isLoadingErrorRate} tip="加载中..."></Spin>
                                            <div style={{ height: '300px', width: '100%', float: 'left'}}>
                                                <ReactEcharts ref="echarts_react" option={this.getOption1.bind(this)(errorRateChart)} notMerge={true}/>
                                            </div>
                                        </TabPane>
                                        <TabPane tab="表" key="2">
                                            <Spin spinning={isLoadingErrorRate} tip="加载中..."></Spin>
                                            <Table
                                                columns={columns}
                                                dataSource={errorRate}
                                                pagination={false}
                                                defaultExpandAllRows={false}
                                            />
                                        </TabPane>
                                    </Tabs>
                            </div>
                    </div> */}
                    {/* <div className="tabTop"   style = {{marginRight: '30px'}}>
                            <h1>到达率，互动率
                                <Icon
                                    className='reload'
                                    type="reload"
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        float: 'right',
                                        marginTop: '5px',
                                        marginRight: '5px',
                                    }}
                                    onClick={()=>{this.props.getErrorRate()}}
                                />
                            </h1>
                            <div className="tabCon">

                                    <Tabs defaultActiveKey="1" tabBarStyle={{background:'#f7f7f7'}}>
                                        <TabPane tab="表" key="2">
                                            <Spin spinning={isLoadingErrorRate} tip="加载中..."></Spin>
                                            <Table
                                                columns={columns0}
                                                dataSource={errorRate}
                                                pagination={false}
                                                defaultExpandAllRows={false}
                                            />
                                        </TabPane>
                                    </Tabs>
                            </div>
                    </div> */}


                    <div className="tabTop"  style = {{marginRight: '30px'}}>
                            <h1>任务带宽消耗
                                <Icon
                                    className='reload'
                                    type="reload"
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        float: 'right',
                                        marginTop: '5px',
                                        marginRight: '5px',
                                    }}
                                    onClick={()=>{this.props.getAllDataSize()}}
                                />
                            </h1>
                            <div className="tabCon">
                                    <Tabs defaultActiveKey="1" tabBarStyle={{background:'#f7f7f7'}}>
                                        <TabPane tab="表" key="2">
                                            <Spin spinning={isLoadingAllDataSize} tip="加载中..."></Spin>
                                            <Table
                                                columns={columns2}
                                                dataSource={allDataSize}
                                                pagination={false}
                                                defaultExpandAllRows={false}
                                            />
                                        </TabPane>
                                    </Tabs>
                            </div>

                    </div>


                    <div className="tabTop">

                            <h1>任务页面大小
                                <Icon
                                    className='reload'
                                    type="reload"
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        float: 'right',
                                        marginTop: '5px',
                                        marginRight: '5px',
                                    }}
                                    onClick={()=>{this.props.getDataSize()}}
                                />
                            </h1>
                            <div className="tabCon">
                                    <Tabs defaultActiveKey="1" tabBarStyle={{background:'#f7f7f7'}}>
                                        {/*<TabPane tab="图" key="1">*/}
                                            {/*<div style={{ height: '300px', width: '100%', float: 'left'}}>*/}
                                                {/*<ReactEcharts ref="echarts_react" option={this.getOption2.bind(this)(charts)} notMerge={true}/>*/}
                                            {/*</div>*/}

                                        {/*</TabPane>*/}
                                        <TabPane tab="表" key="2">
                                            <Spin spinning={isLoadingDataSize} tip="加载中..."></Spin>
                                            <Table
                                                columns={columns3}
                                                dataSource={dataSize}
                                                pagination={false}
                                                defaultExpandAllRows={false}
                                            />
                                        </TabPane>
                                    </Tabs>
                            </div>

                    </div>
                    {/* <div className="tabTop" style = {{marginRight: '30px'}}>

                            <h1>监测代码到达时间
                                <Icon
                                    className='reload'
                                    type="reload"
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        float: 'right',
                                        marginTop: '5px',
                                        marginRight: '5px',
                                    }}
                                    onClick={()=>{this.props.getDataSize()}}
                                />
                            </h1>
                            <div className="tabCon">
                                    <Tabs defaultActiveKey="1" tabBarStyle={{background:'#f7f7f7'}}>
                                        <TabPane tab="表" key="2">
                                            <Spin spinning={isLoadingDataSize} tip="加载中..."></Spin>
                                            <Table
                                                columns={columns4}
                                                dataSource={dataSize}
                                                pagination={false}
                                                defaultExpandAllRows={false}
                                            />
                                        </TabPane>
                                    </Tabs>
                            </div>

                    </div>
                    <div className="tabTop">

                            <h1>任务gap统计
                                <Icon
                                    className='reload'
                                    type="reload"
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        float: 'right',
                                        marginTop: '5px',
                                        marginRight: '5px',
                                    }}
                                    onClick={()=>{this.props.getCheckPvGap()}}
                                />
                            </h1>
                            <div className="tabCon">
                                    <Tabs defaultActiveKey="1" tabBarStyle={{background:'#f7f7f7'}}>
                                        <TabPane tab="表" key="2">
                                            <Spin spinning={isLoadingDataSize} tip="加载中..."></Spin>
                                            <Table
                                                columns={columns5}
                                                dataSource={checkPvGap}
                                                pagination={false}
                                                defaultExpandAllRows={false}
                                            />
                                        </TabPane>
                                    </Tabs>
                            </div>

                    </div> */}


                    <div className="tabTop"  style={{  marginRight: '30px'}}>
                            <h1>代理池监控
                                <Icon
                                    className='reload'
                                    type="reload"
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        float: 'right',
                                        marginTop: '5px',
                                        marginRight: '5px',
                                    }}
                                    onClick={()=>{this.props.asyncGet()}}
                                />
                            </h1>
                            <div className="tabCon">
                                    <Tabs defaultActiveKey="1" tabBarStyle={{background:'#f7f7f7'}}>
                                        <TabPane tab="代理" key="1">
                                            <Spin spinning={isLoadingAllProxyPoolLength} tip="加载中..."></Spin>
                                            <Table
                                                columns={columns1}
                                                dataSource={list}
                                                pagination={false}
                                                defaultExpandAllRows={false}
                                            />
                                        </TabPane>
                                    </Tabs>
                            </div>

                    </div>


                    {/*<div className="tabTop">
                            <h1>设备号监控(地区)
                                <Icon
                                    className='reload'
                                    type="reload"
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        float: 'right',
                                        marginTop: '5px',
                                        marginRight: '5px',
                                    }}
                                    onClick={()=>{this.props.getDeviceInfo()}}
                                />
                            </h1>
                            <div className="tabCon">
                                    <Tabs defaultActiveKey="1" tabBarStyle={{background:'#f7f7f7'}}>
                                        <TabPane tab="表" key="2">
                                            <Spin spinning={isLoadingDeviceInfo} tip="加载中..."></Spin>
                                            <Table
                                                columns={clolumnsForDevices}
                                                dataSource={deviceInfo}
                                                pagination={false}
                                                defaultExpandAllRows={false}
                                            />
                                        </TabPane>
                                    </Tabs>
                            </div>
                    </div>
                    <div className="tabTop" style={{  marginRight: '30px'}}>
                        <h1>设备号监控(任务)
                            <Icon
                                className='reload'
                                type="reload"
                                style={{
                                    cursor: 'pointer',
                                    fontSize: '20px',
                                    color: '#000',
                                    fontWeight: 'bold',
                                    float: 'right',
                                    marginTop: '5px',
                                    marginRight: '5px',
                                }}
                                onClick={()=>{this.props.getTaskDeviceInfo()}}
                            />
                            <br/>
                            <DatePicker onChange={this.handleSearch} format={dateFormat} defaultValue={moment(moment().format(dateFormat))}/>
                        </h1>
                        <div className="tabCon">
                            <Tabs defaultActiveKey="1" tabBarStyle={{background:'#f7f7f7'}}>
                                <TabPane tab="表" key="2">
                                    <Spin spinning={isLoadingTaskDeviceInfo} tip="加载中..."></Spin>
                                    <Table
                                        columns={clolumnsTaskForDevices}
                                        dataSource={taskDeviceInfo}
                                        pagination={false}
                                        defaultExpandAllRows={false}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>



                <div className="tabTop"  style={{  marginRight: '30px'}}>
                    <h1>任务阻塞监控
                        <Icon
                            className='reload'
                            type="reload"
                            style={{
                                cursor: 'pointer',
                                fontSize: '20px',
                                color: '#000',
                                fontWeight: 'bold',
                                float: 'right',
                                marginTop: '5px',
                                marginRight: '5px',
                            }}
                            onClick={()=>{this.props.getBlockingTaskMonitorUrl()}}
                        />
                    </h1>
                    <div className="tabCon">
                        <Tabs defaultActiveKey="1" tabBarStyle={{background:'#f7f7f7'}}>
                            <TabPane tab="表" key="1">
                                <Spin spinning={isLoadingBlockingTaskMonitorQuery} tip="加载中..."></Spin>
                                <Table
                                    columns={columnsBlockingTaskMonitorQuery}
                                    expandedRowRender={record => expandedRowRender(record)}
                                    dataSource={dataBlockingTaskMonitorQuery}
                                    pagination={false}
                                    defaultExpandAllRows={false}
                                />
                            </TabPane>
                        </Tabs>
                    </div>

                </div> */}

            </div>
        );
    }
}

const mapStateToProps = state => ({
    getTest: state.pie.getTest,
    errorRate: state.pie.errorRate,
    errorRateChart: state.pie.errorRateChart,
    charts: state.agencyAnalysis.proxyinfo,
    // selectedContent: state.discardList.selectedContent,
    list: state.pie.list,
    allDataSize: state.pie.allDataSize,
    dataSize: state.pie.dataSize,
    checkPvGap: state.pie.checkPvGap,
    // pagination: state.discardList.pagination,
    // proxyrepeatinfo: state.discardList.proxyrepeatinfo,
    uiStatus: state.pie.uiStatus,
    // agentsGroup: state.discardList.agentsGroup,
    // transferData: state.discardList.transferData,
    // threadList: state.discardList.threadList,
    deviceInfo: state.pie.deviceInfo,
    taskDeviceInfo: state.pie.taskDeviceInfo,
    blockingTaskMonitorQuery: state.pie.blockingTaskMonitorQuery,
    searchValues: state.pie.searchValues,
});
const mapDispatchToProps = dispatch => ({
    getTestA: () => dispatch(getTestA()),
    getErrorRate: () => dispatch(getErrorRate()),
    getErrorRateChart: () => dispatch(getErrorRateChart()),
    getAllDataSize: () => dispatch(getAllDataSize()),
    getDataSize: () => dispatch(getDataSize()),
    asyncGet: () => dispatch(asyncGet()),
    delProxyKey: keyName => dispatch(delProxyKey(keyName)),
    getDeviceInfo: () => dispatch(getDeviceInfo()),
    getTaskDeviceInfo: ()=> dispatch(getTaskDeviceInfo()),
    changeTaskDeviceSearchValues: values => dispatch(actions.changeTaskDeviceSearchValues(values)),
    getCheckPvGap: () => dispatch(getCheckPvGap()),
    getBlockingTaskMonitorUrl: () => dispatch(getBlockingTaskMonitorUrl()),
    // editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    // changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    // delUser: id => dispatch(actions.del(id)),
    // delect: record => dispatch(delect(record)),
    // delectAll: selectedRowsCurr1 => dispatch(delectAll(selectedRowsCurr1)),
    // getTransferData: data => dispatch(actions.getTransferData(data)),
    // changePagination: data => dispatch(actions.changePagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);



// WEBPACK FOOTER //
// ./pages/monitor/name/index.js